var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container bottom-margin",attrs:{"aria-label":"404 - Page Not Found"}},[_c('vue-headful',{attrs:{"head":{
      'meta[name]': { name: 'robots', content: 'noindex' },
    }}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg-12 mt-5"},[_c('h1',[_vm._v("This Campaign Cannot Be Found")]),_c('p',[_vm._v("We could not find the campaign you were looking for.")]),_c('p',[_vm._v("Please feel free to search for other possibilites as well.")])])
}]

export { render, staticRenderFns }